import { Box, Fab, makeStyles } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import adminRoutesConstant from '../../../constants/adminRoutesConstant';
import { bannerHeadCells } from '../../../constants/headCells/masterDataHeadCells';
import { permissionNames } from '../../../constants/permissions';
import { getAllBanners, updateBanner } from '../../../services/masterDataService';
import { getTableCrudByPermission } from '../../../utils/other';
import Button from '../../commons/Button/Button';
import AppModal from '../../commons/Modal/AppModal';
import ScreenWrapper from '../../commons/ScreenWrapper';
import Table from '../../commons/Table/dataTable/Table';
import Text from '../../commons/Text';

const useStyles = makeStyles(theme => ({
    preview: {
        width: '20rem',
        height: 'auto',
    }
}))

const AllBannerScreen = () => {
    const classes = useStyles()
    const admin = useSelector(state => state.auth.admin)
    const history = useHistory()
    const [allBanners, setAllBanners] = React.useState([])
    const [bannerToDelete, setBannerToDelete] = React.useState(null)

    const goToEditPage = (eachData) => {
        history.push(adminRoutesConstant.adminUrls.BannerEditFormScreen.url(String(eachData.id)));
    }

    const goToViewPage = (eachData) => {
        history.push(adminRoutesConstant.adminUrls.BannerViewFormScreen.url(String(eachData.id)));
    }

    const handleModalClose = () => {
        setBannerToDelete(null)
    }

    const handleDeleteBanner = () => {
        updateBanner({
            ...bannerToDelete,
            is_active: 0,
            is_deleted: 1,
        }, bannerToDelete.id).then(response => {
            console.log(response);
            handleModalClose()
            fetchAllBanners();
        })
    }

    const handleSetBannerToDelete = row => {
        setBannerToDelete(row)
    }

    const handleAction = (rowData, actionKey) => {

        switch (actionKey) {
            case permissionNames.CAN_READ:
                goToViewPage(rowData);
                return;

            case permissionNames.CAN_UPDATE:
                goToEditPage(rowData);
                return;

            case permissionNames.CAN_DELETE:
                handleSetBannerToDelete(rowData)
                return;
            default:
                return;
        };

    }

    const fetchAllBanners = () => {
        getAllBanners().then(response => {
            setAllBanners(response)
        })
    }

    React.useEffect(() => {
        fetchAllBanners()
    }, [])

    return (
        <ScreenWrapper
            pageTitle="All Banners"

            // ? info: To implement create button based on roles, add the below line in ternary operator conditioning
            // admin.permission && admin.permission.Plans && admin.permission.Plans.canCreate == '1'
            ActionComponent={() => (true) ? (
                <Link to={adminRoutesConstant.adminUrls.BannerCreateFormScreen.url()} style={{ textDecoration: 'none' }}>
                    <Fab size='small' variant="extended" color="primary" aria-label="add">
                        <Add /> Add New Banner
                    </Fab>
                </Link >
            ) : null}
        >
            <Table
                tableName='Showing all Banners'
                headCells={bannerHeadCells}
                tableData={allBanners}
                onClickAction={handleAction}
                crud={getTableCrudByPermission(admin.permission && admin.permission.Plans)}
            />
            <AppModal
                open={!!bannerToDelete}
                onClose={handleModalClose}
                hideClose
                title='Are you sure you want to delete these banners?'
            >
                {
                    bannerToDelete && (
                        <>
                            <div style={{ textAlign: 'center' }}>
                                <img className={classes.preview} src={bannerToDelete.web_banner} alt='web banner' />
                            </div>
                            <Text margin='0 0 2rem 0' fontWeight={600} textAlign='center'>Web Banner</Text>
                            <div style={{ textAlign: 'center' }}>
                                <img className={classes.preview} src={bannerToDelete.mobile_banner} alt='mobile banner' />
                            </div>
                            <Text margin='0 0 2rem 0' fontWeight={600} textAlign='center'>Mobile Banner</Text>
                            <Box display='flex' justifyContent='center' mt={4}>
                                <Button margin='0 1rem 0 0' onClick={handleDeleteBanner}>Yes, Delete it!</Button>
                                <Button variant='contained' color='primary' onClick={handleModalClose}>Cancel</Button>
                            </Box>
                        </>
                    )
                }
            </AppModal>
        </ScreenWrapper>
    )
}

export default AllBannerScreen